import { schema } from 'normalizr'

const shopProductOrder = new schema.Entity('shopProductOrders', {})

export default shopProductOrder
